import { useQuery } from '@tanstack/react-query';
import { getDistinctValuesForFilter } from './getGLControlData';

interface RegionOption {
  label: string;
  value: string;
}

export const fetchRegions = async (controlId: string, country: string): Promise<RegionOption[]> => {
  if (controlId !== 'grc18956') {
    return [];
  }
  const regions = await getDistinctValuesForFilter(controlId, 'region', undefined, country);
  return regions.map((region) => ({ label: region, value: region }));
};

export const useRegion = (controlId: string, country: string) =>
  useQuery({
    queryKey: ['regions', controlId, country],
    queryFn: () => fetchRegions(controlId, country),
    enabled: Boolean(controlId && country),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
